import * as React from 'react';
import type { JSX } from 'react';
import * as styles from './RedesignIntroduction.css';
import { clsx } from 'clsx';

interface IDefaultIntroductionProps {
  breadcrumbs: React.ReactNode;
  backgroundImage?: string;
  backgroundSlider: JSX.Element | null;
  title: React.ReactNode;
  logo: React.ReactNode;
  contacts: React.ReactNode;
  rating: React.ReactNode;
  disclaimer: JSX.Element | null;
}

export function RedesignIntroduction({
  disclaimer,
  breadcrumbs,
  backgroundImage,
  backgroundSlider,
  logo,
  title,
  contacts,
  rating,
}: IDefaultIntroductionProps) {
  return (
    <section id="main" className={styles['introduction']}>
      {backgroundSlider ? (
        <div className={styles['slider']}>{backgroundSlider}</div>
      ) : (
        <div className={styles['image']}>
          {backgroundImage && <img src={backgroundImage} className={styles['poster']} fetchPriority="high" />}
        </div>
      )}
      <div className={styles['breadcrumbs']}>{breadcrumbs}</div>
      <div
        className={clsx(
          styles['content'],
          !backgroundSlider && !backgroundImage && styles['content--small'],
          !!backgroundImage && !!disclaimer && styles['content--with-disclaimer'],
          !!backgroundSlider && styles['content-slider'],
        )}
      >
        {disclaimer && (
          <div data-testid="FskIntroDisclaimer" className={styles['disclaimer-wrapper']}>
            {disclaimer}
          </div>
        )}
        <div className={styles['content__wrapper']}>
          <div className={styles['developer']}>
            <div className={styles['logo']}>{logo}</div>
            <div className={styles['developer-info']}>
              {rating}
              {title}
            </div>
          </div>
          <div className={styles['contacts']}>{contacts}</div>
        </div>
      </div>
    </section>
  );
}
